/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_Retention_ReferralInputs */

const tr_cerez_retention_referral = /** @type {(inputs: Cerez_Retention_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlk girişte kod işlenene ya da silinene kadar`)
};

const en_cerez_retention_referral = /** @type {(inputs: Cerez_Retention_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Until the code is applied at the first sign-in or deleted`)
};

const de_cerez_retention_referral = /** @type {(inputs: Cerez_Retention_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis der Code bei der ersten Anmeldung übernommen oder gelöscht ist`)
};

const ru_cerez_retention_referral = /** @type {(inputs: Cerez_Retention_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока код не будет применён при первом входе или удалён`)
};

/**
* | output |
* | --- |
* | "Until the code is applied at the first sign-in or deleted" |
*
* @param {Cerez_Retention_ReferralInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_retention_referral = /** @type {((inputs?: Cerez_Retention_ReferralInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_Retention_ReferralInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_retention_referral(inputs)
	if (locale === "de") return de_cerez_retention_referral(inputs)
	if (locale === "ru") return ru_cerez_retention_referral(inputs)
	return tr_cerez_retention_referral(inputs)
});